// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueRouter from 'vue-router'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import * as echarts from 'echarts';
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})
Vue.prototype.$echarts = echarts

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.config.productionTip = false

/* URL */
Vue.prototype.GetServerUrl = function() {
  return 'https://api.exshopee.cn'
  // return 'http://192.168.0.9:9000/exshopee'
}

/* URL */
Vue.prototype.PromoteUrl = function() {
  return 'https://seller.exshopee.cn'
  // return 'http://192.168.1.4:8080'
}

/* URL */
Vue.prototype.GetServerLink = function() {
  return 'https://seller.exshopee.cn/'
  // return 'http://192.168.1.4:8080'
}

/* URL */
Vue.prototype.LanguageList = function(etype) {
  let lang = [];
  if(etype == 0){
    lang = [{
      id: "en",
      type: etype,
      title: "中文 - 英文"
    }, {
      id: "may",
      type: etype,
      title: "中文 - 马来"
    }, {
      id: "spa",
      type: etype,
      title: "中文 - 西班牙"
    }, {
      id: "id",
      type: etype,
      title: "中文 - 印尼语"
    }, {
      id: "fra",
      type: etype,
      title: "中文 - 法语"
    }, {
      id: "pt",
      type: etype,
      title: "中文 - 葡萄牙"
    }, {
      id: "pl",
      type: etype,
      title: "中文 - 波兰"
    }];
  }else{
    lang = [{
      id: "en",
      type: etype,
      title: "中文 - 英文"
    }, {
      id: "zh-TW",
      type: etype,
      title: "中文 - 繁体"
    }, {
      id: "vi",
      type: etype,
      title: "中文 - 越南"
    }, {
      id: "th",
      type: etype,
      title: "中文 - 泰语"
    }, {
      id: "ms",
      type: etype,
      title: "中文 - 马来"
    }, {
      id: "id",
      type: etype,
      title: "中文 - 印尼"
    }, {
      id: "es",
      type: etype,
      title: "中文 - 西班牙"
    }, {
      id: "pt",
      type: etype,
      title: "中文 - 葡萄牙"
    }, {
      id: "pl",
      type: etype,
      title: "中文 - 波兰"
    }];
  }

  return lang;
}

/* 时间戳转时间 */
function filling(m) {
  return m < 10 ? '0' + m : m
}
Vue.prototype.timestampToTime = function(format) {
  var time = new Date(format * 1000);
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  return y + '-' + filling(m) + '-' + filling(d) + ' ' + filling(h) + ':' + filling(mm) + ':' + filling(s);
}

/* 跳转页面 */
Vue.prototype.GoToPage = function(url) {
  this.$router.push({
    path: url
  }) // 路由跳转
}

/* 页面导航设置 */
Vue.prototype.SetNavActive = function(headNav,leftNav) {
  localStorage.setItem("ExShopee_Sort", headNav); //缓存头部导航
  localStorage.setItem("ExShopee_HistoryURL", leftNav); //缓存一级导航URL
}

/* 页面导航设置 */
Vue.prototype.UppercaseConversion = function(str) {
  return str.toLowerCase().split(' ').map(item=>{
   return item.replace(item.charAt(0),item[0].toUpperCase())
  }).join(' ')
}

/* 时间转换 */
Vue.prototype.formatDate = function(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  return [year, month, day].join('-');
}

Vue.prototype.getDate = function(t, backFun, etype) {
  var dateTime = new Date();
  var dates = t.split(' - ')
  var start_time = dates[0]
  if (dates[1]) {
    var end_time = new Date(dates[1]);
    if(!etype){
      end_time = end_time.setDate(end_time.getDate() + 1);
    }
    end_time = this.formatDate(new Date(end_time));
  }
  backFun(start_time, end_time);
}

Vue.prototype.getDateThreeMonthsAgo = function() {  
    // 获取当前日期和时间  
    const currentDate = new Date();  
  
    // 设置月份为当前月份减去3（注意JavaScript中月份是从0开始的）  
    currentDate.setMonth(currentDate.getMonth() - 3);  
  
    // 为了确保日期仍然有效（比如避免1月31日减去3个月变成前一年的10月31日，但10月只有30天），  
    // 我们可以创建一个新的Date对象，并仅复制年、月和日（忽略时间部分）  
    const year = currentDate.getFullYear();  
    const month = currentDate.getMonth(); // 注意：这里返回的是0-11  
    const day = currentDate.getDate();  
  
    // 返回一个新的Date对象，表示三个月前的日期（时间部分设置为00:00:00）  
    return new Date(year, month, day, 0, 0, 0, 0);  
}

Vue.prototype.maskString = function(str) {
    // 检查字符串长度是否小于等于2，如果是则直接返回原字符串  
    if (str.length <= 2) {  
        return str;  
    }  
  
    // 获取第一个字符和最后一个字符  
    const firstChar = str[0];  
    const lastChar = str[str.length - 1];  
  
    // 计算中间部分的长度，并生成相应数量的星号  
    const middleLength = str.length - 2;  
    const middleStars = '*'.repeat(middleLength);  
  
    // 拼接结果字符串  
    return firstChar + middleStars + lastChar;  
}

//图片处理
Vue.prototype.$picture = function(str) {
  if(!str || typeof str != 'string') return str;
  str = str.replace(/https:\/\/cbu01.alicdn.com/, 'https://exshopee.com');
  return str;  
}

/* 返回结果处理 */
Vue.prototype.ReturnFuntion = function(self, res, success, error, toast) {
  self.loading = false;
  var json = res.data;
  if (json.code == 200) {
    success(json.datas);
  } else if (json.code == 401) {
    self.GoToPage("/");
  } else {
    if (error) {
      error(json)
    }
    if (toast) { //是否弹窗提醒
      self.ToastFun(2, json.msg);
    } else {
      console.log(json.msg);
    }
  }
}

/* 显示分页 */
Vue.prototype.ShowPage = function(self, laypage, e, num) {
  var limit = 20;
  if (num) {
    limit = num;
  }
  laypage.render({
    elem: 'pagebox',
    curr: self.page,
    limit:self.page_num,
    limits: [20, 50, 100, 200 ,500],
    layout: ['prev', 'page', 'next','limit'],
    count: self.count,
    jump: function(obj, first) {
      if (!first) {
        // console.log(obj.curr); //得到当前页，以便向服务端请求对应页的数据。
        // console.log(obj.limit); //得到每页显示的条数
        self.page = obj.curr;
        self.page_num = obj.limit;
        self.gotop = true;
        self.list = [];
        eval("self." + e + "()");
      }
    }
  });
  self.isAll = false;
  $('.cxall').prop('checked', false);
}

Vue.prototype.ShowSpacePage = function(self, laypage, e, pages) {
  self.Spaceimgs = [];
  laypage.render({
    elem: 'SpacePage',
    curr: self.SpacePage,
    limit: 20,
    count: pages.count,
    jump: function(obj, first) {
      if (!first) {
        self.SpacePage = obj.curr;
        eval("self." + e + "("+self.SpacePage+")");
      }
    }
  });
}

//弹出模态框
var layerIndex = 0;
var update_date;
Vue.prototype.modal_box_show = function(self, te, title, datas) {
  var w, h;
  if (title == null || title == '') {
    title = false;
  };
  if (w == null || w == '') {
    w = $(window).width() - 260;
  };
  if (h == null || h == '') {
    h = $(window).height() - 95;
  };

  var content_html;
  content_html = eval(te)

  var laydate, form;
  layui.use(['form', 'laydate'], function() {
    laydate = layui.laydate;
    form = layui.form;
    layerIndex = layer.open({
      type: 1,
      area: [w + 'px', h + 'px'],
      fix: false, //不固定
      shadeClose: true,
      shade: 0.4,
      title: title,
      content: content_html,
      success: function(layero, index) {
        update_date = laydate.render({
          elem: '#update_date',
          range: true,
          min: -30,
          max: 0,
        });

        if (te == "SynchronizeOrders") { //店铺选择
          var shop_list = self.shop_list;
          var chtml = ""
          for (var i in shop_list) {
            chtml += "<option data-country='" + shop_list[i].country + "' value='" + shop_list[i].id + "'>" +
              shop_list[i].name + "-" + shop_list[i].country + "</option>"
          }
          $("#shop_list").html(chtml);
        } else if (te == "Categories") {
          self.ClassifyHtml(datas);
        }

        //物流列表赋值
        if (self.loglist) {
          var html = "";
          var loglist = self.loglist;
          if (loglist.length > 0) {
            for (let item in loglist) {
              html += "<option value='" + loglist[item].logistics_channel_id + "'>" + loglist[item].logistics_channel_name +
                "</option>"
            }
            $("#HandoverCompany").val(loglist[0].logistics_channel_name);
            $("#log_select").html(html);
          }
        }

        //首公里选择
        form.on('radio(kilometer)', function(data) {
          if ($('#kilometer input[name="fkg"]:checked').val() == "否") {
            $(".logbox").hide();
          } else {
            $(".logbox").show();
          }
          form.render();
        });

        //店铺类型
        form.on('radio(ShopType)', function(data) {
          console.log($('#ShopType input[name="ShopType"]:checked').val())
          if ($('#ShopType input[name="ShopType"]:checked').val() == "1") {
            $(".OrdinaryShop").show();
            $(".GlobalShop").hide();
          } else {
            $(".OrdinaryShop").hide();
            $(".GlobalShop").show();
          }
          form.render();
        });

        //定价规则
        form.on('radio(PricingType)', function(data) {
          var ptype = $('#PricingType input[name="PricingType"]:checked').val();
          if (ptype == "1") {
            $(".ProfitOne").show();
            $(".ProfitTwo").hide();
            $(".ProfitThree").hide();
          } else if(ptype == "2"){
            $(".ProfitOne").hide();
            $(".ProfitTwo").show();
            $(".ProfitThree").hide();
          } else {
            $(".ProfitOne").hide();
            $(".ProfitTwo").hide();
            $(".ProfitThree").show();
          }
          form.render();
        });

        //下拉框选中
        form.on('select(log_select)', function(data) { //选择移交单位 赋值给input框
          var select_text = data.elem[data.elem.selectedIndex].text;
          $("#HandoverCompany").val(select_text);
          $("#log_select").next().find("dl").css({
            "display": "none"
          });
          form.render();
        });

        //搜索输入框搜索
        $('#HandoverCompany').bind('input propertychange', function() {
          var value = $("#HandoverCompany").val();
          $("#log_select").val(value);
          form.render();
          $("#log_select").next().find("dl").css({
            "display": "block"
          });
          var dl = $("#log_select").next().find("dl").children();
          var j = -1;
          for (var i = 0; i < dl.length; i++) {
            if (dl[i].innerHTML.indexOf(value) <= -1) {
              dl[i].style.display = "none";
              j++;
            }
            if (j == dl.length - 1) {
              $("#log_select").next().find("dl").css({
                "display": "none"
              });
            }
          }
        });

        //添加折扣
        form.on('submit(AddPromotion)', function(data) {
          self.AddPromotion();
        });

        //列表内容为空
        if(te == "PromotionList"){
          if(!datas || datas.length <= 0){
            $('.PromotionNull').show();
          }else{
            $('.PromotionNull').hide();
          }
        }

      },
      end: function(){
        if (te == "OrderBale") {
          self.stock_id = null;
          self.stock_number = null;
        }
      }
    });

    if (datas) {

      //待打包
      if (te == "OrderBale") {

        //仓库信息
        for(let i in self.shop_list){
          if(self.shop_list[i].id == self.shop_id){
            var ix = self.shop_list[i].warehouse-1;
            var name = localStorage.getItem("ExShopee_id");
            var phone = self.addressList[ix].phone;
            var address = self.addressList[ix].address;
            var xml = '<li>'
            xml += '<p>收件人：</p>'
            xml += '<p>黑领科技'+name+'</p>'
            xml += '</li>'
            xml += '<li>'
            xml += '<p>联系电话：</p>'
            xml += '<p>'+phone+'</p>'
            xml += '</li>'
            xml += '<li>'
            xml += '<p>收货地址：</p>'
            xml += '<p>'+address+'</p>'
            xml += '</li>'
            $(".modal_address").html(xml);
          }
        }

        if (datas.shipment_number && datas.shipment_number.length > 0) {
          var txt = (datas.shipment_number).join("\n");
          $("#shipment_number").val(txt);
        }
        if (datas.buyer_message) {
          $("#buyer_message").val(datas.buyer_message);
        }

        //修改打包时 订单首公里不为空，隐藏按钮首公里按钮
        if (datas.first_mile_tracking_number) {
          $('.kilometerbox').hide();
        }

        var arr = Object.keys(self.attach);
        if(arr.length > 0){
          var ehtml = "";
          var chtml = '<option value="0">默认耗材</option>';
          var ghtml = '<option value="0">无</option>';

          for(let x in self.attach[3]){
            if(x == 0){
              ehtml += '<input type="radio" name="etype" value="'+self.attach[3][x].id+'" title="'+self.attach[3][x].name+'" lay-filter="etype" checked>'
            }else{
              ehtml += '<input type="radio" name="etype" value="'+self.attach[3][x].id+'" title="'+self.attach[3][x].name+'" lay-filter="etype">'
            }
          }
          if(datas.bao_server){
            $("#etype input[name=etype][value='"+datas.bao_server.etype.id+"']").prop("checked", "true");
          }

          for(let i in self.attach[1]){
            if(datas.bao_server && datas.bao_server.consumables.id == self.attach[1][i].id){
              chtml += '<option value='+self.attach[1][i].id+' selected="true">'+self.attach[1][i].name +'('+ self.attach[1][i].value +'积分)</option>'
            }else{
              chtml += '<option value='+self.attach[1][i].id+'>'+self.attach[1][i].name +'('+ self.attach[1][i].value +'积分)</option>'
            }
          }
          for(let j in self.attach[2]){
            if(datas.bao_server && datas.bao_server.gift.id == self.attach[2][j].id){
              ghtml += '<option value='+self.attach[2][j].id+' selected="true">'+self.attach[2][j].name +'('+ self.attach[2][j].value +'积分)</option>'
            }else{
              ghtml += '<option value='+self.attach[2][j].id+'>'+self.attach[2][j].name +'('+ self.attach[2][j].value +'积分)</option>'
            }
          }
          $("#etype").html(ehtml);
          $("#consumables").html(chtml);
          $("#gift").html(ghtml);
        }

        if(datas.bao_server){
          $("#etype input[name=etype][value='"+datas.bao_server.etype.id+"']").prop("checked", "true");
        }

        //打包产品列表
        var xhtml = "";
        var datalist = datas.order_datas.items;
        for (let item in datalist) {
          let pid;
          if (datas.order_datas.items[item].variation_id) {
            pid = datas.order_datas.items[item].variation_id;
          } else {
            pid = datas.order_datas.items[item].item_id;
          }
          if (!datalist[item].sid) {
            datalist[item].sid = 0
          }

          xhtml += '<div class="product-fsbox" style="padding-bottom:30px;" data-sku="'+datalist[item].item_sku+'" data-number="'+datalist[item].variation_quantity_purchased+'">'
          xhtml += '<tr class="product_box">'
          xhtml += '<td colspan="14" class="product_box_tr" style="border:0;">'
          xhtml += '<div class="product_box">'
          xhtml += '<div class="table-header">'
          xhtml += '<table class="layui-table" style="min-width: 700px;">'
          xhtml += '<thead>'
          xhtml += '<tr class="trth">'
          xhtml += '<th>图片</th>'
          xhtml += '<th>SKU</th>'
          xhtml += '<th>名称</th>'
          xhtml += '<th>规格</th>'
          xhtml += '<th>数量</th>'
          xhtml += '</tr>'
          xhtml += '</thead>'
          xhtml += '<tbody class="images" v-viewer>'
          xhtml += '<tr v-for="val in item.order_datas.items">'
          xhtml += '<td class="table_img"><img src="' + datalist[item].img + '"></td>'
          xhtml += '<td style="width:100px">' + datalist[item].item_sku + '</td>'
          xhtml += '<td><div class="onlyOneRow" style="max-width:200px;">' + datalist[item].item_name +
            '</div></td>'
          xhtml += '<td>' + datalist[item].variation_name + '</td>'
          xhtml += '<td>' + datalist[item].variation_quantity_purchased + '</td>'
          xhtml += '</tr>'
          xhtml += '</tbody>'
          xhtml += '</table>'
          xhtml += '</div>'
          xhtml += '</div>'
          xhtml += '</td>'
          xhtml += '</tr>'

          xhtml += '<ul class="Logboxlist">'
          if (datalist[item].shipment_number.length > 0) {
            for (let val in datalist[item].shipment_number) {
              xhtml +=
                '<div class="product_main" style="padding-bottom:10px !important;min-width:700px;" data-id="' +
                datalist[item].shipment_number[val].sid + '" data-sku="'+datalist[item].item_sku+'" data-number="'+datalist[item].variation_quantity_purchased+'" data-pid="' + pid + '">'

              xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
              xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">快递单号</label>'
              xhtml += '<div class="layui-input-inline">'
              if (datalist[item].shipment_number[val].number) {
                xhtml += '<input type="text" value="' + datalist[item].shipment_number[val].number +
                  '" autocomplete="off" class="layui-input lognumber">'
              } else {
                xhtml += '<input type="text" autocomplete="off" class="layui-input lognumber">'
              }
              xhtml += '</div>'
              xhtml += '</div>'

              xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
              xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">留言备注</label>'
              xhtml += '<div class="layui-input-inline">'
              if (datalist[item].shipment_number[val].remark) {
                xhtml += '<input type="text" value="' + datalist[item].shipment_number[val].remark +
                  '" autocomplete="off" class="layui-input remark">'
              } else {
                xhtml += '<input type="text" autocomplete="off" class="layui-input remark">'
              }
              xhtml += '</div>'
              xhtml += '</div>'

              xhtml +=
                '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="stockSelect" style="background:#FFF;padding:9px 0;" lay-submit>库存选择</button>'
              xhtml +=
                '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="deletelog" style="background:#FFF;padding:9px 0;padding-left:10px;" lay-submit>删除</button>'
              xhtml += '</div>'
            }
          } else {
            xhtml +=
              '<div class="product_main" style="padding-bottom:10px !important;min-width:700px;" data-id="0" data-sku="'+datalist[item].item_sku+'" data-number="'+datalist[item].variation_quantity_purchased+'" data-pid="' +
              pid + '">'

            xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
            xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">快递单号</label>'
            xhtml += '<div class="layui-input-inline">'
            xhtml += '<input type="text" autocomplete="off" class="layui-input lognumber">'
            xhtml += '</div>'
            xhtml += '</div>'

            xhtml += '<div class="layui-input-inline" style="margin-right:15px;margin-top:10px;">'
            xhtml += '<label class="layui-form-label" style="padding:9px 0;text-align:left;width:70px">留言备注</label>'
            xhtml += '<div class="layui-input-inline">'
            xhtml += '<input type="text" autocomplete="off" class="layui-input remark">'
            xhtml += '</div>'
            xhtml += '</div>'

            xhtml +=
              '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="stockSelect" style="background:#FFF;padding:9px 0;" lay-submit>库存选择</button>'
            xhtml +=
              '<button class="NoSelect layui-input-inline deleteLog NoSelect" type="button" lay-filter="deletelog" style="background:#FFF;padding:9px 0;padding-left:10px;" lay-submit>删除</button>'
            xhtml += '</div>'
          }

          xhtml += '</ul>'

          xhtml += '<div class="layui-input-item" style="padding-bottom:20px !important;">'
          xhtml += '<button data-pid="' + pid +
            '" data-number="'+datalist[item].variation_quantity_purchased+'" data-ix="'+item+'" class="NoSelect addlogbox" style="cursor: pointer;color: #01AAED;background:#FFF" type="button" lay-filter="addlog" lay-submit><i class="fa fa-plus"></i> 添加快递单号</button>'
          xhtml += '</div>'


          xhtml += '</div>'
        }

        $('#product-fs-box').html(xhtml);


      } else if (te == "Pricing") {

        //普通店铺
        if (!self.empty(datas.is_fee_ship)) {
          $(".FreeShip").attr("checked", JSON.parse(datas.is_fee_ship));
        }
        if (!self.empty(datas.is_ccb)) {
          $(".Cbb").attr("checked", JSON.parse(datas.is_ccb));
        }
        if (!self.empty(datas.is_support)) {
          $(".Hatch").attr("checked", JSON.parse(datas.is_support));
        }
        if (datas.is_merchant == 2) {
          $(".OrdinaryShop").hide();
          $("input[name=ShopType][value='2']").prop("checked", "true");
        }

        if (datas.e_type == 1) {
          $("#profit_margin").val(datas.profit);
          $(".ProfitOne").show();
          $(".ProfitTwo").hide();
          $(".ProfitThree").hide();
          $("input[name=PricingType][value='1']").prop("checked", "true");
        }
        if (datas.e_type == 2) {
          $("#profit").val(datas.profit);
          $(".ProfitOne").hide();
          $(".ProfitTwo").show();
          $(".ProfitThree").hide();
          $("input[name=PricingType][value='2']").prop("checked", "true");
        }
        if (datas.e_type == 3) {
          $("#profit_margin_order").val(datas.profit);
          $(".ProfitOne").hide();
          $(".ProfitTwo").hide();
          $(".ProfitThree").show();
          $("input[name=PricingType][value='3']").prop("checked", "true");
        }
        $("#other_fee").val(datas.other_fee);
        $("#system_fee").val(datas.system_fee);
        $("#pay_fee").val(datas.pay_fee);
        $("#discounts").val(datas.discounts);
        $("#PricingName").val(datas.name);
        $("#mantissa").val(datas.ws_handle);
        if(datas.ws_handle > 0){
          $("#mantissa_money").val(datas.ws_money);
          $(".mantissa_money").show();
        }

      } else if (te == "PromotionList") { //促销列表
        var chtml = ""
        for (var i in datas) {
          chtml += '<tr>'
					chtml += '<td>'+ datas[i].discount_id +'</td>'
					chtml += '<td>'+datas[i].discount_name+'</td>'
					chtml += '<td>'
          if(datas[i].status == "upcoming"){
            chtml += '<i class="status-box status-box-red">即将开始的活动</i>'
          }else{
            chtml += '<i class="status-box status-box-red">进行中</i>'
          }
          chtml += '</td>'
					chtml += '<td>'
					chtml += '<div>开始：'+self.timestampToTime(datas[i].start_time)+'</div>'
					chtml += '<div>结束：'+self.timestampToTime(datas[i].end_time)+'</div>'
					chtml += '</td>'
					chtml += '<td><button class="layui-btn layui-btn-normal" lay-filter="PromotionSubmit" data-id="'+datas[i].discount_id +'" data-name="'+datas[i].discount_name+'" type="button" lay-submit>选择</button></td>'
					chtml += '</tr>'
        }
        $("#table-html").html(chtml);
      } else if (te == "Categories") {
        self.ClassifyHtml(datas);
      }

    }else{
      //批量待打包
      if (te == "OrderBatchBale") {

        var arr = Object.keys(self.attach);
        if(arr.length > 0){
          var ehtml = "";
          var chtml = '<option value="0">默认耗材</option>';
          var ghtml = '<option value="0">无</option>';

          for(let x in self.attach[3]){
            if(x == 0){
              ehtml += '<input type="radio" name="etype" value="'+self.attach[3][x].id+'" title="'+self.attach[3][x].name+'" lay-filter="etype" checked>'
            }else{
              ehtml += '<input type="radio" name="etype" value="'+self.attach[3][x].id+'" title="'+self.attach[3][x].name+'" lay-filter="etype">'
            }
          }
          for(let i in self.attach[1]){
            chtml += '<option value='+self.attach[1][i].id+'>'+self.attach[1][i].name +'('+ self.attach[1][i].value +'积分)</option>'
          }
          for(let j in self.attach[2]){
            ghtml += '<option value='+self.attach[2][j].id+'>'+self.attach[2][j].name +'('+ self.attach[2][j].value +'积分)</option>'
          }
          $("#etype").html(ehtml);
          $("#consumables").html(chtml);
          $("#gift").html(ghtml);
        }
      }
    }

    form.render();


  });


}

//关闭模态框
Vue.prototype.modal_box_close = function() {
  layer.close(layerIndex);
}

//获取文字字节长度
Vue.prototype.GetBytesLength = function(str) {
  var strlen = 0;
  if(str){
    for (var i = 0; i < str.length; i++) {
    	if (str.charCodeAt(i) > 255) //如果是汉字，则字符串长度加2
    		strlen += 2.25;
    	else
    		strlen++;
    }
  }
  return Math.ceil(strlen);
}

//数组判断
Vue.prototype.isInArray = function(arr, value) {
  for (var i = 0; i < arr.length; i++) {
    if (value === arr[i]) {
      return true;
    }
  }
  return false;
}

//判断为无效值
Vue.prototype.empty = function(v) {
  switch (typeof v) {
    case 'undefined':
      return true;
    case 'string':
      if (trim(v).length == 0 || v == "undefined" || v == "null" || v == "false" || v == "NaN")
        return true;
      break;
    case 'boolean':
      if (!v)
        return true;
      break;
    case 'number':
      if (0 === v)
        return true;
      break;
    case 'object':
      if (null === v)
        return true;
      if (undefined !== v.length && v.length == 0)
        return true;
      for (var k in v) {
        return false;
      }
      return true;
      break;
  }
  return false;
}

function trim(str) {
  for (var i = 0; i < str.length && str.charAt(i) == "  "; i++)
  ;
  for (var j = str.length; j > 0 && str.charAt(j - 1) == "  "; j--)
  ;
  if (i > j)
    return "";
  return str.substring(i, j);
}

//运费计算
Vue.prototype.FreightCount = function(isSpecial,cy, weight) {
  // weight = 400; //测试

  //获取汇率
  var freight;
  for (let i in country) {
    if (country[i].en_name == cy) { //国家判断

      if (weight < country[i].first_weight) { //如果重量不大于首重重量，直接返回首重价格
        freight = country[i].first_fee;

        //台湾特货
        if(cy == "TW" && isSpecial == 1){
          freight = 45;  //首重费用
        }

        // console.log(freight)
        return freight;
      } else {
        let decimal = country[i].decimal; //保留小数
        let fweight = country[i].first_weight; //首重
        let cweight = country[i].continued_weight; //续重重量
        let ffee = country[i].first_fee; //首重费用
        let cfee = country[i].continued_fee; //续重费用
        let arrival_fee = country[i].arrival_fee; //达标续重费用
        let arrival_weight = country[i].arrival_weight; //达标重量
        let count = Math.ceil((weight - fweight) / cweight); //超重次数

        //台湾特货
        if(cy == "TW" && isSpecial == 1){
          ffee = 45;  //首重费用
          cfee = 40;  //续重费用
          arrival_fee = 40; //达标续重费用
        }

        freight = (count * cfee + ffee).toFixed(decimal);

        // if (arrival_fee != cfee && weight >= arrival_weight) { //续重达标后续重价格不同计算
        //   freight = freight - ((count - 7) * cfee - (count - 7) * arrival_fee);
        // }

        //台湾续重特殊处理
        if(cy == "TW"){
          var exes = 0;
          if(weight > 2500){
            let count = Math.ceil((weight - 2500) / cweight); //超重次数
            exes = count * 30 + 40;
          }else if(weight > 2000){
            exes = 40;
          }else if(weight > 1500){
            exes = 20;
          }else if(weight > 1000){
            exes = 10;
          }
          freight = parseFloat(freight) + exes;
        }

        // console.log(freight)
        return freight;
      }

    }
  }

}

//普通店定价工具
Vue.prototype.PricingTool = function(cy, weight, datas, pricing, te) {

  var roe, decimal;
  for (let i in country) {
    if (country[i].en_name == cy) {
      roe = country[i].exchange; //汇率
      decimal = country[i].decimal; //保留小数
    }
  }

  //计算价格
  for (let x in datas) {
    if (datas[x].istrue) {
      let price = Number(datas[x].price);
      let dprice = datas[x].price_before_discount;
      datas[x].diskaun = pricing.discounts;

      //定价计算
      let this_weight
      if(weight){
        this_weight = weight;
      }else{
        this_weight = 0;
      }
      if(datas[x].weight){
        this_weight = datas[x].weight;
      }
      //有重量才定价
      if(this_weight > 0 && datas[x].price){
        if (pricing.e_type == 1) { //利润率
          datas[x].price = ((price + pricing.other_fee) * (1 + pricing.profit * 0.01) * roe + parseFloat(this.FreightCount(this.datas.isSpecial,cy, this_weight, datas))) / (1 - (pricing.system_fee * 0.01));
        } else { //固定利润
          datas[x].price = (((price + pricing.other_fee + pricing.profit) * roe) + parseFloat(this.FreightCount(this.datas.isSpecial,cy, this_weight, datas))) / (1 - (pricing.system_fee * 0.01));
        }
        if(pricing.discounts > 0){
          datas[x].price_before_discount = datas[x].price * (1 / (pricing.discounts * 0.1)); //自动计算折扣前的价格
        }else{
          datas[x].price_before_discount = datas[x].price;
          datas[x].diskaun = 10;
        }

        //尾数处理方式
        if(pricing.ws_handle == 0){
          datas[x].price = datas[x].price.toFixed(decimal); //四舍五入
          datas[x].price_before_discount = datas[x].price_before_discount.toFixed(decimal); //四舍五入
        }else if(pricing.ws_handle == 1){
          datas[x].price = Math.round(datas[x].price); //四舍五入
          datas[x].price_before_discount = Math.round(datas[x].price_before_discount); //四舍五入
        }else if(pricing.ws_handle == 2){
          datas[x].price = Math.ceil(datas[x].price); //向上取整
          datas[x].price_before_discount = Math.ceil(datas[x].price_before_discount); //四舍五入
        }else if(pricing.ws_handle == 3){
          datas[x].price = Math.floor(datas[x].price); //向下取整
          datas[x].price_before_discount = Math.floor(datas[x].price_before_discount); //四舍五入
        }

        //尾数金额大于当前金额
        var price_str = datas[x].price.toString();
        var price_before_str = datas[x].price_before_discount.toString();
        if(pricing.ws_handle > 0){
          var ws_money_str = pricing.ws_money.toString();
          if(price_str.length > ws_money_str.length){
            datas[x].price = price_str.substring(0,price_str.length-ws_money_str.length) + ws_money_str;
          }
        }else{
          if (cy == "VN") { //越南站点自动抹0
            datas[x].price = price_str.substring(0, price_str.length - 3) + "000";
            datas[x].price_before_discount = price_before_str.substring(0, price_before_str.length - 3) + "000";
          }
        }

        if (te) {
          this.datas.customize_tier_variations[x] = datas[x];
        } else {
          this.datas.price = datas[x].price;
          this.datas.price_before_discount = datas[x].price_before_discount;
          this.datas.diskaun = datas[x].diskaun;
        }
      }
    }
  }

  this.$forceUpdate();
}

//批量普通店定价工具
Vue.prototype.AllPricingTool = function(pix, cy, weight, datas, pricing, te) {

  var roe, decimal;
  for (let i in country) {
    if (country[i].en_name == cy) {
      roe = country[i].exchange; //汇率
      decimal = country[i].decimal; //保留小数
    }
  }

  //计算价格
  for (let x in datas) {
    if (datas[x].istrue && datas[x].price > 0) {
      let price = Number(datas[x].price);
      let dprice = datas[x].price_before_discount;
      datas[x].diskaun = pricing.discounts;

      //定价计算
      let this_weight
      if(weight){
        this_weight = weight;
      }else{
        this_weight = 0;
      }
      if(datas[x].weight){
        this_weight = datas[x].weight;
      }
      if(this_weight > 0 && datas[x].price){
        if (pricing.e_type == 1) { //利润率
          datas[x].price = ((price + pricing.other_fee) * (1 + pricing.profit * 0.01) * roe + parseFloat(this.FreightCount(this.list[pix].data.isSpecial,cy, this_weight, datas))) / (1 - (pricing.system_fee *
            0.01));

        } else { //固定利润
          datas[x].price = (((price + pricing.other_fee + pricing.profit) * roe) +
            parseFloat(this.FreightCount(this.list[pix].data.isSpecial,cy, this_weight, datas))) / (1 - (pricing.system_fee * 0.01));
        }
        if(pricing.discounts > 0){
          datas[x].price_before_discount = datas[x].price * (1 / (pricing.discounts * 0.1)); //自动计算折扣前的价格
        }else{
          datas[x].price_before_discount = datas[x].price;
          datas[x].diskaun = 10;
        }

        //尾数处理方式
        if(pricing.ws_handle == 0){
          datas[x].price = datas[x].price.toFixed(decimal); //四舍五入
          datas[x].price_before_discount = datas[x].price_before_discount.toFixed(decimal); //四舍五入
        }else if(pricing.ws_handle == 1){
          datas[x].price = Math.round(datas[x].price); //四舍五入
          datas[x].price_before_discount = Math.round(datas[x].price_before_discount); //四舍五入
        }else if(pricing.ws_handle == 2){
          datas[x].price = Math.ceil(datas[x].price); //向上取整
          datas[x].price_before_discount = Math.ceil(datas[x].price_before_discount); //四舍五入
        }else if(pricing.ws_handle == 3){
          datas[x].price = Math.floor(datas[x].price); //向下取整
          datas[x].price_before_discount = Math.floor(datas[x].price_before_discount); //四舍五入
        }

        //尾数金额大于当前金额
        var price_str = datas[x].price.toString();
        var price_before_str = datas[x].price_before_discount.toString();
        if(pricing.ws_handle > 0){
          var ws_money_str = pricing.ws_money.toString();
          if(price_str.length > ws_money_str.length){
            datas[x].price = price_str.substring(0,price_str.length-ws_money_str.length) + ws_money_str;
          }
        }else{
          if (cy == "VN") { //越南站点自动抹0
            datas[x].price = price_str.substring(0, price_str.length - 3) + "000";
            datas[x].price_before_discount = price_before_str.substring(0, price_before_str.length - 3) + "000";
          }
        }

        if (te) {
          this.list[pix].data.customize_tier_variations[x] = datas[x];
        } else {
          this.list[pix].data.price = datas[x].price;
          this.list[pix].data.price_before_discount = datas[x].price_before_discount;
          this.list[pix].data.diskaun = datas[x].diskaun;
        }
      }else{
        layer.msg("定价前请输入重量！");
        return;
      }
    }
  }
  this.$forceUpdate();
}

//全球店定价工具
Vue.prototype.PricingToolGlobal = function(datas, pricing, te) {

  //计算价格
  for (let x in datas) {
    if (datas[x].istrue && datas[x].price > 0) {
      let price = Number(datas[x].price);

      //定价计算
      if (pricing.e_type == 1) { //利润率
        datas[x].price = ((price + pricing.other_fee) * (1 + pricing.profit * 0.01)).toFixed(2);
      } else { //固定利润
        datas[x].price = (price + pricing.other_fee + pricing.profit).toFixed(2);
      }

      if (te) {
        this.datas.customize_tier_variations[x] = datas[x];
      } else {
        this.datas.price = datas[x].price;
      }
    }
  }

  this.$forceUpdate();
}

//批量全球店店定价工具
Vue.prototype.AllPricingToolGlobal = function(pix, cy, weight, datas, pricing, te) {

  //计算价格
  for (let x in datas) {
    if (datas[x].istrue && datas[x].price > 0) {
      let price = Number(datas[x].price);

      //定价计算
      if (pricing.e_type == 1) { //利润率
        datas[x].price = ((price + pricing.other_fee) * (1 + pricing.profit * 0.01)).toFixed(2);
      } else { //固定利润
        datas[x].price = (price + pricing.other_fee + pricing.profit).toFixed(2);
      }

      //尾数处理方式
      // if(pricing.ws_handle == 0){
      //   datas[x].price = datas[x].price.toFixed(2); //四舍五入
      // }else if(pricing.ws_handle == 1){
      //   datas[x].price = Math.round(datas[x].price); //四舍五入
      // }else if(pricing.ws_handle == 2){
      //   datas[x].price = Math.ceil(datas[x].price); //向上取整
      // }else if(pricing.ws_handle == 3){
      //   datas[x].price = Math.floor(datas[x].price); //向下取整
      // }

      //尾数金额大于当前金额
      // var price_str = datas[x].price.toString();
      // if(pricing.ws_handle > 0){
      //   var ws_money_str = pricing.ws_money.toString();
      //   if(price_str.length > ws_money_str.length){
      //     datas[x].price = price_str.substring(0,price_str.length-ws_money_str.length) + ws_money_str;
      //   }
      // }

      if (te) {
        this.list[pix].data.customize_tier_variations[x] = datas[x];
      } else {
        this.list[pix].data.price = datas[x].price;
        this.list[pix].data.price_before_discount = datas[x].price_before_discount;
        this.list[pix].data.diskaun = datas[x].diskaun;
      }
    }
  }
  this.$forceUpdate();
}

//批量全球店店定价工具
Vue.prototype.PricingToolGlobalRelease = function(money,freight,current_county,pricing) {
  if(pricing.e_type == 3){
    var price = ((money+pricing.other_fee)*current_county.exchange+freight) / (1 - ((pricing.system_fee + pricing.profit) *0.01))
  }else{
    var price = (money*current_county.exchange+freight) / (1 - (pricing.system_fee *0.01));
  }

  if(pricing.discounts > 0){
    var price_before_discount = price * (1 / (pricing.discounts * 0.1)); //自动计算折扣前的价格
  }else{
    var price_before_discount = price;
  }

  //尾数处理方式
  if(pricing.ws_handle == 0){
    price = price.toFixed(current_county.decimal); //四舍五入
    price_before_discount = price_before_discount.toFixed(current_county.decimal); //四舍五入
  }else if(pricing.ws_handle == 1){
    price = Math.round(price); //四舍五入
    price_before_discount = Math.round(price_before_discount); //四舍五入
  }else if(pricing.ws_handle == 2){
    price = Math.ceil(price); //向上取整
    price_before_discount = Math.ceil(price_before_discount); //四舍五入
  }else if(pricing.ws_handle == 3){
    price = Math.floor(price); //向下取整
    price_before_discount = Math.floor(price_before_discount); //四舍五入
  }

  //尾数金额大于当前金额
  var price_str = price.toString();
  if(pricing.ws_handle > 0){
    var ws_money_str = pricing.ws_money.toString();
    if(price_str.length > ws_money_str.length){
      price = price_str.substring(0,price_str.length-ws_money_str.length) + ws_money_str;
    }
  }else{
    if (current_county.en_name == "VN") { //越南站点自动抹0
      price = price_str.substring(0, price_str.length - 3) + "000";
    }
  }

  return [price,price_before_discount];
}


Vue.prototype.SizeList = function() {
 const size_list = ["XS","S","M","L","XL","2XL","3XL","4XL","5XL","XXL","XXXL","XXXXL","XXXXXL","均码","小码","中码","大码"];
  return size_list;
}

Vue.prototype.$bus = this;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  beforeCreate(){
    Vue.prototype.$bus = this;
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js